export default "__VITE_ASSET__DDHJINUI__"